// Copies the SKU/item number shown next to the description on the product page.
// Delegated at document level, not bound per-button on load: product-info.js swaps the whole
// #Sku-x element's innerHTML on every variant change (see sections/main-product.liquid's own
// comment on the 'sku' block), so a button bound at load would be replaced and go dead the first
// time a shopper changes color or size. Delegation means every freshly-swapped-in button just
// works without any re-bind step.
(function () {
  var RESET_DELAY_MS = 2000;
  var resetTimers = new WeakMap();

  function readSkuValue(button) {
    var row = button.closest('.product__sku');
    var valueEl = row && row.querySelector('[data-sku-value]');
    return valueEl ? valueEl.textContent.trim() : '';
  }

  function showCopied(button) {
    var icon = button.querySelector('[data-copy-icon]');
    var success = button.querySelector('[data-copy-icon-success]');
    if (icon) icon.hidden = true;
    if (success) success.hidden = false;
    button.classList.add('is-copied');

    var existingTimer = resetTimers.get(button);
    if (existingTimer) window.clearTimeout(existingTimer);
    resetTimers.set(
      button,
      window.setTimeout(function () {
        if (icon) icon.hidden = false;
        if (success) success.hidden = true;
        button.classList.remove('is-copied');
        resetTimers.delete(button);
      }, RESET_DELAY_MS)
    );
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-copy-sku]');
    if (!button) return;

    var value = readSkuValue(button);
    if (!value || !navigator.clipboard) return;

    navigator.clipboard.writeText(value).then(function () {
      showCopied(button);
    });
  });
})();
